var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkedinIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.9999 18.0001V12.1401C17.9999 9.26006 17.3799 7.06006 14.0199 7.06006C12.3999 7.06006 11.3199 7.94006 10.8799 8.78006H10.8399V7.32006H7.65991V18.0001H10.9799V12.7001C10.9799 11.3001 11.2399 9.96006 12.9599 9.96006C14.6599 9.96006 14.6799 11.5401 14.6799 12.7801V17.9801H17.9999V18.0001Z",
  fill: "#0073DE"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.26001 7.32007H5.58001V18.0001H2.26001V7.32007Z",
  fill: "#0073DE"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.92 2C2.86 2 2 2.86 2 3.92C2 4.98 2.86 5.86 3.92 5.86C4.98 5.86 5.84 4.98 5.84 3.92C5.84 2.86 4.98 2 3.92 2Z",
  fill: "#0073DE"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedinIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/linkedinIcon.ade13bf632172160377c5e96e4ed5b00.svg";